import { render } from "./Cart.vue?vue&type=template&id=12ca1dab&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=12ca1dab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12ca1dab"

export default script